import { getSiteTextFallbackContent } from "@Front/Stores/defaultSiteTextFallbacks";

function fallbackTrimToMap(value: string, textKey: string, locale: string): string {
	if (typeof value === "string" && value.trim().length > 0) {
		return value;
	}
	return getSiteTextFallbackContent(textKey, locale) ?? "";
}

export type StepEmailSiteTextsDisplay = {
	welcomeTitleDisplay: string;
	welcomeSubtitleDisplay: string;
	ssoProSectionTitleDisplay: string;
	ssoProCtaDisplay: string;
	ssoOauthLoginPresetSectionTitleDisplay: string;
	clientsSectionTitleDisplay: string;
	emailPlaceholderDisplay: string;
	emailLabelDisplay: string;
	submitCtaDisplay: string;
};

type RawSiteTextFields = {
	locale: string;
	welcomeTitle: string;
	welcomeSubtitle: string;
	ssoProSectionTitle: string;
	ssoProCta: string;
	ssoOauthLoginPresetSectionTitle: string;
	clientsSectionTitle: string;
	emailPlaceholder: string;
	emailLabel: string;
	submitCta: string;
};

export function buildStepEmailSiteTextsDisplay(raw: RawSiteTextFields): StepEmailSiteTextsDisplay {
	const { locale } = raw;
	return {
		welcomeTitleDisplay: fallbackTrimToMap(raw.welcomeTitle, "login.header.title", locale),
		welcomeSubtitleDisplay: fallbackTrimToMap(raw.welcomeSubtitle, "login.header.subtitle", locale),
		ssoProSectionTitleDisplay: fallbackTrimToMap(raw.ssoProSectionTitle, "login.section.ssoPro.title", locale),
		ssoProCtaDisplay: fallbackTrimToMap(raw.ssoProCta, "login.section.ssoPro.cta", locale),
		ssoOauthLoginPresetSectionTitleDisplay: fallbackTrimToMap(
			raw.ssoOauthLoginPresetSectionTitle,
			"login.section.ssoOauthLoginPresets.title",
			locale,
		),
		clientsSectionTitleDisplay: fallbackTrimToMap(raw.clientsSectionTitle, "login.section.clients.title", locale),
		emailPlaceholderDisplay: fallbackTrimToMap(raw.emailPlaceholder, "login.form.email.placeholder", locale),
		emailLabelDisplay: fallbackTrimToMap(raw.emailLabel, "login.form.email.label", locale),
		submitCtaDisplay: fallbackTrimToMap(raw.submitCta, "login.form.submit", locale),
	};
}
